import { buildCrmSwalBody, fireConfirmDialog } from './swalConfirm';

export async function confirmCatalogExit({ cartCount = 0 } = {}) {
  if (cartCount > 0) {
    return fireConfirmDialog({
      title: '¿Volver al chat?',
      html: buildCrmSwalBody({
        lead: `Tenés <strong>${cartCount}</strong> producto${cartCount === 1 ? '' : 's'} en el carrito.`,
        footnote: 'Si volvés sin «Agregar al carrito», perdés esa selección.'
      }),
      icon: 'warning',
      confirmButtonText: 'Volver sin guardar',
      cancelButtonText: 'Seguir eligiendo'
    });
  }

  return fireConfirmDialog({
    title: '¿Volver al chat?',
    html: buildCrmSwalBody({
      lead: 'Vas a salir del catálogo y volver a la conversación con Anita.'
    }),
    icon: 'question',
    confirmButtonText: 'Volver al chat',
    cancelButtonText: 'Cancelar'
  });
}
